import { useEffect, useState } from "react";

const useQueryParam = (key: string) => {
  const getParam = () => new URLSearchParams(window.location.search).get(key);
  const [value, setValue] = useState(getParam());

  useEffect(() => {
    let prev = getParam();
    const interval = setInterval(() => {
      const curr = getParam();
      if (curr !== prev) {
        prev = curr;
        setValue(curr);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [key]);

  return value;
};

export default useQueryParam;
